module.exports = __webpack_public_path__ + "static/img/__9016.1893798.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9016.jpg
// module id = lL9F
// module chunks = 0